import * as React from 'react';
import { Route, Redirect } from 'react-router';

export const AuthRedirectRoute = ({ component: Component, ...rest }: any) => {
    return (
        <Route
            {...rest}
            render={props => (
                localStorage.getItem('WF_APPLICATION')
                    ? <Component {...props} />
                    : <Redirect to="/auth/signin" />
            )}
        />
    );
}
